import { DigimapViewer } from '@digimap/digimap-core-viewer';

export class MessageHandler {
  private previousData: any = null;
  private clickHandler: (event: Event) => void;
  private messageHandler: (event: MessageEvent) => void;
  // Cleanup for the viewer's parent-window label-theme message listener.
  private themeListenerCleanup: (() => void) | null = null;

  constructor() {
    this.clickHandler = this.handleClick.bind(this);
    this.messageHandler = this.handleMessage.bind(this);
  }

  init() {
    document.addEventListener('click', this.clickHandler, true);
    window.addEventListener('message', this.messageHandler);
    // Forward parent-window label theme overrides (CMS iframe host) into the
    // viewer. Idempotent on the viewer side, so re-mounts are safe.
    this.themeListenerCleanup = DigimapViewer.setupThemeMessageListener();
  }

  destroy() {
    document.removeEventListener('click', this.clickHandler, true);
    window.removeEventListener('message', this.messageHandler);
    this.themeListenerCleanup?.();
    this.themeListenerCleanup = null;
  }

  private handleMessage(event: MessageEvent) {
    if (event.data?.type === 'CALL_FUNCTION') {
      const { functionName, params } = event.data;

      if ((window as any).digimap?.[functionName]) {
        const result = (window as any).digimap[functionName](params);
        window.parent.postMessage(
          {
            type: 'FUNCTION_RESULT',
            functionName,
            result,
          },
          '*',
        );
      }
    }
  }

  private handleClick(event: Event) {
    const target = event.target as HTMLElement;

    if (target.id === 'digimap' || target.closest('#digimap')) {
      setTimeout(() => {
        const currentData = (window as any).digimap.getDataClickMap();
        window.parent.postMessage(
          {
            type: 'MAP_CLICKED',
            data: currentData,
          },
          '*',
        );
      }, 50);
    }
  }
}
